<template>
    <Portal>
        <div
            :class="['sideMenu ' + classes, idMenu, { collapsed: isCollapsed }]"
            @mouseleave="onLeave"
            :ref="idMenu"
            :style="{ width: `${width}px` }">
            <a class="btn-toggleSidebar" @click.prevent="onToggleSidebar">
                <Icon name="Menu" />
            </a>
            <div class="inner" style="overflow: hidden">
                <template v-if="enableResize">
                    <div class="resizer" @mousedown="onResizerDown" :ref="`resizer.${idMenu}`"></div>
                </template>
                <slot name="back"></slot>
                <template v-if="enableShow">
                    <button class="button is-sidebar" @click="onPin">
                        <span>
                            <template v-if="isPinned">
                                <span class="icon">
                                    <Icon name="UnPin" />
                                </span>
                            </template>
                            <template v-else-if="!$slots.trigger">
                                <span class="icon">
                                    <Icon name="Pin" />
                                </span>
                            </template>
                            <template v-else>
                                <slot name="trigger"></slot>
                            </template>
                        </span>
                    </button>
                </template>
                <div @mouseover="onOver" class="flex-1">
                    <slot></slot>
                </div>
            </div>
        </div>

        <div class="sideMenu-Overlay" v-if="showOverlay" @click="collapseMenu"></div>
    </Portal>
</template>

<script>
import { Portal } from '@linusborg/vue-simple-portal';
const SIDEMENU_WIDTH = 60;
const SIDEMENU_EXPANDED_WIDTH = 300;

/**
 * idMenu is mandatory!
 * */
import Icon from './../public/Icon.vue';
export default {
    name: 'Sidemenu',
    components: {
        Icon,
        Portal,
    },
    props: {
        value: {
            type: Boolean,
        },
        idMenu: {
            type: String,
            required: true,
        },
        hasOverlay: {
            type: Boolean,
            default: false,
        },
        defaultClosed: {
            type: Boolean,
            default: false,
        },
        classes: {
            type: String,
            default: '',
        },
        enablePin: {
            type: Boolean,
            default: false,
        },
        disablePinHoverDelay: {
            type: Boolean,
            default: false,
        },
        enableShow: {
            type: Boolean,
            default: true,
        },
        saveState: {
            type: Boolean,
            default: true,
        },
        autoWidth: {
            type: Boolean,
            default: true,
        },
        enableResize: {
            type: Boolean,
            default: false,
        },
        sidemenuWidth: {
            type: Number,
            default: SIDEMENU_WIDTH,
        },
        sidemenuWidthExpanded: {
            type: Number,
            default: SIDEMENU_EXPANDED_WIDTH,
        },
    },
    data: function () {
        return {
            isCollapsed: false,
            isPinned: false,
            isOver: false,
            reactiveObject: 0,
        };
    },
    watch: {
        value(val) {
            if (val === true) {
                this.isCollapsed = false;
            }
        },
    },
    computed: {
        showOverlay() {
            return this.hasOverlay ? !this.isCollapsed : false;
        },
        savedWidth: {
            get: function () {
                this.reactiveObject;
                let stored = localStorage.getItem(`sidemenu.${this.idMenu}.width`);
                return stored ? JSON.parse(stored) : this.sidemenuWidthExpanded;
            },
            set: function (newValue) {
                localStorage.setItem(`sidemenu.${this.idMenu}.width`, JSON.stringify(newValue));
                this.reactiveObject++; //small hack to make reactive
            },
        },
        width() {
            if (this.isCollapsed) {
                return this.sidemenuWidth;
            } else {
                const maxSize = window.innerWidth - 150;
                return this.savedWidth > maxSize ? maxSize : this.savedWidth;
            }
        },
    },
    created() {
        document.addEventListener(`sideMenu_${this.idMenu}.show`, this.expandMenu);
        document.addEventListener(`sideMenu_${this.idMenu}.hide`, this.collapseMenu);
    },
    mounted() {
        if (this.defaultClosed) {
            this.collapseMenu();
        } else {
            this.handleSavedState();
        }
    },
    beforeDestroy() {
        var mainElement = document.getElementsByTagName('main').item(0);
        mainElement.style.paddingLeft = null;
        document.removeEventListener(`sideMenu_${this.idMenu}.show`, this.expandMenu);
        document.removeEventListener(`sideMenu_${this.idMenu}.hide`, this.collapseMenu);
    },
    methods: {
        handleSavedState() {
            this.isPinned = localStorage.getItem(`sidemenu.${this.idMenu}.isPinned`) === 'true';
            this.isCollapsed = this.isPinned ? false : true;
            if (this.enableResize && !this.isCollapsed) {
                this.handleSavedWidth();
            }
            this.handlePadding();
        },
        handleSavedWidth() {
            if (this.savedWidth) {
                this.setSize(this.savedWidth);
            }
        },
        handleAutoWidth() {
            /* not working atm: when reloading page with open sidebar content padding is not correct because sidebar hasn't reached it full width
      //auto width sidebar
      var sidebar = this.$refs[this.idMenu];
      if (this.autoWidth && !this.enableResize) {
        sidebar.classList.add("notransition");
        sidebar.style.width = this.isCollapsed ? null : "auto";
        let adjustedSidebar = sidebar.cloneNode(true);
        console.log(this.idMenu + ": width set", adjustedSidebar.style.width);
      }*/
        },
        handlePadding() {
            this.handleAutoWidth();

            //add spacing to body, only when no overlay is used
            if (!this.hasOverlay) {
                this.$nextTick(() => {
                    var sidebar = this.$refs[this.idMenu];
                    var mainElement = document.getElementsByTagName('main').item(0);
                    var newLeftPadding = this.isCollapsed ? this.sidemenuWidth : sidebar.clientWidth;
                    mainElement.style.paddingLeft = `${newLeftPadding}px`;
                });
            }
        },
        expandMenu() {
            this.isCollapsed = false;
            this.isPinned = true;
            if (this.enableResize) {
                this.handleSavedWidth();
            }
            this.$emit('input', false);
        },
        collapseMenu() {
            this.isCollapsed = true;
            this.isPinned = false;
            if (this.saveState) {
                localStorage.setItem(`sidemenu.${this.idMenu}.isPinned`, this.isPinned);
            }
            if (this.enableResize) {
                var sidebar = this.$refs[this.idMenu];
                if (sidebar) {
                    sidebar.style.width = null;
                }
            }
            this.handlePadding();
            this.$emit('input', false);
            document.removeEventListener('mouseUp', this.onResizerUp);
        },
        onOver() {
            //add small delay before showing
            this.isOver = true;
            const delay = this.disablePinHoverDelay ? 100 : 1500;
            setTimeout(() => {
                if (this.isOver) {
                    this.isCollapsed = false;
                    //this.handlePadding();
                    this.handleAutoWidth();
                }
            }, delay);
        },
        onLeave() {
            this.isOver = false;
            //ignore if sidebar has an overLay
            if (!this.hasOverlay) {
                this.isCollapsed = this.isPinned ? false : true;
                this.handlePadding();
            }
        },
        onPin() {
            if (this.isPinned) {
                this.collapseMenu();
            } else {
                this.isPinned = this.isPinned ? false : true;
                this.isCollapsed = this.isPinned ? false : true;

                if (this.enableResize) {
                    this.handleSavedWidth();
                }

                if (this.saveState) {
                    localStorage.setItem(`sidemenu.${this.idMenu}.isPinned`, this.isPinned);
                }
                this.handlePadding();
            }
        },
        setSize(size) {
            const maxSize = window.innerWidth - 150;
            const minSize = 150;

            //handle restrictions
            if (size > maxSize) {
                size = maxSize;
            }
            if (size < minSize) {
                size = minSize;
            }
            this.$refs[this.idMenu].style.width = `${size}px`;
        },
        resize(e) {
            e.preventDefault();
            const boundingClientRect = this.$refs[this.idMenu].getBoundingClientRect();
            const x = boundingClientRect.x;
            const change = x - e.x;
            const w = boundingClientRect.width;
            const size = w + change + 20; //15 width of resizer

            this.setSize(size);
        },
        onResizerDown(e) {
            e.preventDefault();
            if (this.idMenu && this.$refs[`resizer.${this.idMenu}`]) {
                this.$refs[`resizer.${this.idMenu}`].classList.add('onDrag');
                document.addEventListener('mousemove', this.resize);
                document.addEventListener('mouseup', this.onResizerUp);
            }
        },
        onResizerUp(e) {
            if (this.idMenu && this.$refs[`resizer.${this.idMenu}`]) {
                this.$refs[`resizer.${this.idMenu}`].classList.remove('onDrag');
            }
            //save the width
            this.savedWidth = this.$refs[this.idMenu].clientWidth;
            document.removeEventListener('mousemove', this.resize);
            document.removeEventListener('mouseup', this.onResizerUp);
        },
        onToggleSidebar() {
            document.dispatchEvent(new Event('toggleSidebar'));
        },
    },
};
</script>

<style lang="scss">
.notransition {
    -webkit-transition: none !important;
    -moz-transition: none !important;
    -o-transition: none !important;
    transition: none !important;
}

.flex-1 {
    flex: 1;
}

/* Optional Overlay
========================================================== */
.sideMenu-Overlay {
    background-color: var(--sidemenu-overlay-bg);
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 10000;
    cursor: pointer;
}

/* Default styling
========================================================== */
.sideMenu {
    position: fixed;
    top: 0;
    z-index: 8888;
    //margin-left: 15px;
    //height: calc(100vh - 60px);
    height: 100vh;
    padding: 0 15px 15px 15px;
    display: block;
    transition: width 200ms ease-out, left 200ms ease-out;

    background-color: transparent;
    padding: 15px 0;
    background-color: red;

    padding-top: 0 !important;

    .btn-toggleSidebar {
        position: absolute;
        right: -50px;
        top: 0;
        width: 100%;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin: 15px 0;
        padding-left: 22px;
        padding-right: 22px;
        color: var(--color-txt);
        opacity: 0.5;
        z-index: 88;

        &:hover {
            opacity: 1;
        }
    }

    .inner {
        position: relative;

        display: flex;
        height: 100vh;
        width: 100%;
        padding: 0 15px 0 15px;

        //box-shadow: 5px 5px 10px #dddddd, -5px -5px 10px #ffffff;
        //border-radius: 15px;
        border-right: 2px solid #f2f3f3;
        padding-top: 10px;
        background: var(--sidemenu-bg);
    }
    div.header {
        display: flex;
        height: 40px;
        align-items: center;
        margin: 0 -15px;
        padding: 5px 15px 5px;
        border: 0;

        h2 {
            margin: 0;
            font-size: 1.4rem;
            line-height: 40px;
            text-transform: none;
            letter-spacing: 0.02em;
            font-weight: 600;
            color: #888;
            text-transform: uppercase;
        }

        .dropdown .dropdown-menu .has-link a {
            overflow: hidden;
        }
    }

    &.has-back {
        .header {
            margin-top: -15px;
        }
        .scroll-sidemenu {
            height: calc(100vh - 210px); // 55 + 15 + 15
        }
    }
    .back {
        color: var(--color-txt);
        font-size: 1rem;
        margin: 15px 0;
        height: 55px;
        display: flex;
        align-items: center;
        border-bottom: 2px solid #eee;
        padding-bottom: 6px;
        margin-left: -30px; //full size line
        margin-right: -15px; //full size line
        padding-left: 30px;

        .text {
            margin-left: 10px;
        }
    }

    .dropdown {
        &.is-bottom-left .dropdown-menu {
            margin-right: 3px; //room for shadow
        }
        .dropdown-menu {
            margin-left: 3px; //room for shadow
        }
    }

    .scroll-sidemenu {
        height: calc(100vh - 130px); // 55 + 15 + 15
        overflow-x: hidden;
        overflow-y: auto;
        padding-right: 15px; //room for scrollbar
        margin-bottom: 15px;
    }

    .is-filter-pin {
        display: block;
        .icon {
            width: 18px;
            height: 18px;
            color: var(--color-txt);
            svg {
                height: inherit;
                width: inherit;
            }
        }
    }

    .button.is-sidebar {
        position: absolute;
        right: 0px;
        bottom: 15px;
        z-index: 890;
        width: 100%;
        border: none;
        background: none;
        display: flex;
        justify-content: flex-end;

        &:hover,
        &:focus,
        &:active {
            outline: none;
            box-shadow: none;
            span {
                color: #fff;
                background-color: var(--color-primary);
                border-color: var(--color-primary);
                box-shadow: none;
                outline: none;
                .icon svg {
                    color: #fff;
                }
            }
        }

        span {
            border-radius: 100%;
            background-color: #fff;
            border: 1px solid #e9e9e9;
            color: var(--color-txt);
            width: 28px;
            height: 28px;
            font-size: 1.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            .icon {
                width: 14px;
                height: 14px;
                color: var(--color-txt);
                svg {
                    height: inherit;
                    width: inherit;
                }
            }
        }
    }

    .button.is-toggler {
        position: absolute;
        top: 0;
        left: -15px;
        background-color: transparent;
        border-color: transparent;
        height: 100%;
        width: 100%;
        &:hover,
        &:focus {
            box-shadow: none;
            outline: none;
        }
    }

    &.collapsed {
        transition: width 200ms ease-out, left 200ms ease-out;
        .header {
            overflow: hidden;
            opacity: 0;
        }

        &.has-filters {
            button.is-sidebar {
                border-color: var(--success);
                background-color: var(--success);
                color: #fff;
            }
        }

        form {
            display: none;
        }

        .on-collapsed {
            display: inherit;
        }

        .resizer {
            display: none;
        }

        .hide-collapsed,
        .back {
            display: none;
        }

        ul.navbar-nav {
            overflow: hidden;
            li.header {
                position: relative;
                margin-right: 0;
                opacity: 1;
                span {
                    opacity: 0;
                    visibility: hidden;
                }
                &:before {
                    content: '';
                    position: absolute;
                    top: 8px;
                    left: 0;
                    border-top: 2px solid #ccc;
                    display: block;
                    width: 20px;
                }
                &.hideOnCollapse {
                    &:before {
                        opacity: 0;
                        visibility: hidden;
                    }
                }
            }

            li.nav-item {
                a {
                    span {
                        opacity: 0;
                        display: none;
                    }
                    span.icon {
                        display: inline-flex;
                        opacity: 1;
                    }
                }
                .dropdown {
                    .hideOnCollapse {
                        display: none;
                    }
                }
            }
        }
    }

    ul.navbar-nav {
        display: flex;
        flex-direction: column;
        padding-left: 7px;

        li.header {
            font-size: 1.2rem;
            font-weight: bold;
            text-transform: uppercase;
            color: #8b97a4;
            border-bottom: 0;
            height: auto;
            padding: 0;
            margin-top: 1em;
            margin-bottom: 0;
            &:first-child {
                padding-top: 0;
            }
        }
        li.nav-item {
            div.can > a,
            > a {
                padding: 12px 0;
                font-size: 1.6rem;
                color: #8b97a4;
                font-weight: 500;
                background-color: transparent;
                border-color: #eee;

                display: flex;
                align-items: center;
                white-space: nowrap;
                justify-content: flex-start;
                line-height: 18px;

                span.icon {
                    display: inline-flex;
                }

                .icon {
                    margin-right: 10px;
                    height: 18px;
                    width: 18px;
                    svg {
                        height: inherit;
                        width: inherit;
                    }
                }

                &:hover {
                    background-color: transparent;
                    border-color: transparent;
                    color: var(--color-txt);
                }
            }
            .dropdown {
                width: 100%;
                &.is-disabled {
                    opacity: 1;
                    cursor: default;
                }
                .dropdown-trigger .button {
                    color: #8b97a4;
                    text-decoration: none;
                    padding-left: 0;
                    padding-right: 0;
                    margin-left: 1px;
                    width: 100%;
                    &:focus {
                        box-shadow: none;
                        background-color: transparent;
                    }
                    &:hover {
                        color: var(--color-txt);
                        background-color: transparent;
                    }
                }
            }
            &.is-active a {
                color: var(--color-primary);
                background-color: transparent;
                border-color: #eee;
                .icon {
                    opacity: 1;
                }
            }
        }
    }

    .on-collapsed {
        display: none;
    }
    .action {
        margin: 20px 0;
    }

    .resizer {
        width: 5px;
        height: 100%;
        left: 5px;
        top: 0px;
        background-color: transparent;
        position: absolute;
        z-index: 2;
        cursor: col-resize;
        margin: 0;
        padding: 0;
        box-sizing: border-box;

        &:hover,
        &.onDrag {
            background-color: var(--color-primary);
        }

        &:before,
        &:after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            background-color: #00000026;
            -webkit-transition: background-color 0.3s;
            transition: background-color 0.3s;

            transform: translateY(-50%);
            width: 1px;
            height: 30px;
        }
        &:before {
            margin-left: -2px;
        }
    }
}

/* As Detailmenu
========================================================== */
.sideMenu.detailMenu {
    background-color: var(--detailmenu-bg);
    right: 0;
    left: auto;
    z-index: 10100;
    box-shadow: none;

    padding-right: 0;
    //height: calc(100vh - 60px);
    height: 100vh;
    top: 0px;

    .button.is-sidebar {
        display: none;
        left: 5px;
        right: auto;
        top: 20px;

        svg {
            transform: scaleX(-1);
        }
    }

    a.btn-toggleSidebar {
        display: none;
    }

    .inner {
        //box-shadow: -5px 0 20px 0 rgba(0, 0, 0, 0.05);
        border-left: 2px solid #f2f3f3;
        background-color: transparent;
        padding-top: 0;
    }
    .content.content-recent {
        padding: 0 15px;
    }

    &.collapsed {
        button.is-sidebar {
            left: 0px;

            border: 0;
            color: var(--color-txt);
            background-color: transparent;
            opacity: 0.5;
            width: 100%;
            top: 0;
            display: flex;
            align-items: flex-start;
            justify-content: center;

            z-index: 15;
            font-size: 1.8rem;

            padding: 15px 0 0 0;
            height: 100%;

            &:hover,
            &:focus {
                color: var(--color-txt);
                background-color: transparent;
                color: var(--color-primary);
                opacity: 1;
            }
        }

        .content {
            display: none;
            overflow: hidden;
        }
    }

    &.xl:not(.collapsed) {
        width: 640px;
    }

    &.xxl:not(.collapsed) {
        width: 840px;
    }

    .header {
        height: 70px;
        background-color: #fff;
        .dropdown .dropdown-menu {
            width: 100%;
        }

        .dropdown-trigger .button {
            border: 0;
            margin: 0;
            font-size: 1.4rem;
            font-weight: 400;
            background-color: transparent;
            color: var(--color-txt);
            padding: 0;
            text-transform: none;
            border: 0;
            letter-spacing: 0;
            height: auto;

            .icon {
                font-size: 1.2rem;
            }
        }
    }

    .detail-header {
        display: flex;
        height: 80px;
        align-items: center;
        border-bottom: 2px solid #f6f6f6;
        margin-bottom: 15px;
        margin-right: 15px; //room for scrollbar

        display: grid;
        grid-template-columns: auto max-content;
        align-items: center;
        width: 100%;

        h1 {
            color: var(--color-txt);
            font-size: 2rem;
            line-height: 2.4rem;
            font-weight: 600;
            margin: 0 0 5px 0;
            padding: 0;
            //overflow
            flex: 1;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }

        .actions {
            margin-left: auto;
            display: flex;

            button.contact,
            .button {
                color: var(--color-txt-lighten-30);
                margin-left: 10px;
                color: #979797;
                font-size: 1.4rem;
                background-color: transparent;
                border-radius: 100%;

                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                width: 40px;
                height: 40px;
                background-color: var(--background-color-dark);

                span.txt {
                    display: none;
                }

                span.icon {
                    margin: 0;
                }

                &:focus,
                &:hover {
                    box-shadow: none;
                    outline: none;
                    color: var(--color-txt);
                    transition: all 0.2s ease;
                    background-color: var(--background-color-dark);
                }
            }
        }
    }

    .detail-content {
        height: calc(100vh - 265px); // 70 + 10 + 80 + 15
        overflow-x: hidden;
        overflow-y: auto;
        padding-right: 15px; //room for scrollbar

        .date-fields,
        .estimate-fields {
            flex-wrap: wrap;

            .column {
                flex-basis: 50%;
            }
        }

        .date-fields {
            .column {
                &:last-of-type {
                    flex-grow: 0;
                }

                &:nth-child(2) {
                    .dropdown-menu {
                        left: auto;
                        right: 0;
                    }
                }
            }
        }

        .ck.ck-toolbar.ck-toolbar_grouping > .ck-toolbar__items {
            flex-wrap: wrap;
        }

        .ck.ck-toolbar .ck.ck-toolbar__separator {
            display: none;
        }
    }

    .ddm-left-oriented {
        .dropdown .dropdown-menu {
            left: -80px;
        }
    }
}

/* Create new Objects menu
==========================================================
.detailMenu {
    .detail-addmenu {
        margin-top: 15px;
        height: calc(100vh - 95px); //70 +10 +15
        overflow-x: hidden;
        overflow-y: auto;

        .section form .action {
            margin-bottom: 0;
        }
        .buttons {
            a {
                display: flex;
                align-items: center;
                background-color: #fff;
                padding: 15px;
                margin: 0;
                flex: 1 0;
                border: none;
                border-radius: 0px;
                box-shadow: var(--default-box-shadow);

                font-size: 16px;
                line-height: 20px;
                text-transform: none;
                letter-spacing: 0.02em;
                font-weight: 700;
                color: var(--color-txt);

                //font-family: $font-secondary;
                text-transform: uppercase;
                transition: all 0.2s ease-out;
                span.icon {
                    margin-left: auto;
                    opacity: 0.15;
                }

                &:hover,
                &:active {
                    color: var(--success);
                    box-shadow: 0px 5px 10px 0 rgba(0, 0, 0, 0.08);
                    span.icon {
                        opacity: 1;
                    }
                }
            }
        }
        .help-block.warning {
            color: #ff341f;
            margin-bottom: 0.75rem;
        }
    }
}*/
</style>
